<template>
  <div>
    <div id="scanner-input">
      <input id="listener" type="text" autofocus>
    </div>
    <input id="except" @keyup.enter="sendCommand" v-model="command">
  </div>
</template>
<script>
  export default {
    name: 'scanner-input',
    props: {
      onCodeReceive: {
        required: true,
        type: Function
      }
    },
    data () {
      return {
        command: null
      }
    },
    mounted () {
      const that = this
      $(document).scannerDetection({
        minLength: 2,
        timeBeforeScanTest: 200,
        avgTimeByChar: 40,
        preventDefault: true,
        stopPropagation: true,
        ignoreIfFocusOn: '#except',
        // endChar: [],
        onComplete: function(barcode, qty) {
          console.log('OK Scanner ' + barcode)
          // this.code = barcode
          $('#scanner-input input').val(barcode)
          that.onCodeReceive(barcode)
        },
        onError: function(string, qty) {
          if (string === '*') {
            $('#except').focus()
            return
          }
          $('#scanner-input input').val(string)
          console.log('Error scanner ' + string)
        }
      })
    },
    methods: {
      sendCommand () {
        console.log('Doing the command ' + this.command)
        this.command = null
        $('#listener').focus()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/dealer/Scanner.vue